import { ApiDOMError } from '@swagger-api/apidom-error';

/**
 * @public
 */
class DereferenceError extends ApiDOMError {}
export default DereferenceError;